<template>
  <div class="nav">
    <div class="navbar" ref="lists">
      <div class="navbar-wrapper">
        <a
          v-for="(sku, index) in skuList"
          :key="index + 'sku'"
          href="javascript:;"
          class="nav-item"
          :class="sku.sku_id == currentSkuid ? 'current' : '' "
          @click="switchTab(sku.sku_id)"
          v-show="sku.attr_list"
          :data-current="index"
        >
          <span v-for="(guige, index) in sku.attr_list" :key="index" >{{guige.attr_value.value}}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    skuList: {
      type: Array
    }
  },
  data () {
    return {
      // current: 0
    }
  },
  computed: {
    ...mapState('store', ['currentSkuid'])
  },
  methods: {
    ...mapActions('store', ['setCurrentSkuHandler']),
    switchTab (skuid) {
      if (skuid !== this.currentSkuid - 0) {
        const currentSku = this.skuList.find(v => v.sku_id === skuid)
        this.setCurrentSkuHandler({ skuid, currentSku })
        this.$emit('change')
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.navbar {
  .navbar-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  .nav-item {
    padding: 0.1rem;
    margin-right: 0.2rem;
    margin-bottom: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.26rem;
    color: #404040;
    border: 1px solid #979797;
    border-radius: 0.08rem;
    // white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    box-sizing: border-box;
    span {
      padding-right: 0.1rem;
    }
    span:last-child {
      padding-right: 0;
    }
  }
  // .nav-item:nth-child(5n) {
  //   margin-right: 0;
  // }
  .current {
    color: #fff;
    background-color: #63abff;
    border: none;
  }
}
</style>
